import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import AddServicesUnits from '../../../../models/AddServicesUnits';

import { formatCurrency } from '../../../../utils/currencyFormatter';

import commonAddServiceStyles from '../commonAdditionalService/commonAdditionalService.module.css';
import commonStyles from '../../../common/common.module.css';

const TEXT_FIELD_PADDINGS: string = '8px 12px';
const styles = (theme: any) => ({

});

interface BupBreakdownLD7Props {
  classes: any;
  serviceDetails: AddServicesUnits
};

const bupBreakdownLD7 = (props: BupBreakdownLD7Props) => {

  const { classes, serviceDetails } = props;

  return (
    <div className={ commonStyles.inputLabelWrapper } >
      <label className={ commonStyles.inputLabel }> Cost Per Unit </label>
      <TextField
        disabled
        label=""
        defaultValue={ formatCurrency(serviceDetails.cost_usd ? serviceDetails.cost_usd : 0, 2, '$') + ' / Lower Deck LD7' }
        variant="outlined"
        inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
        InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
        InputLabelProps={{ style: { fontWeight: 'bold' } }}
        fullWidth
      />
    </div>
  );
}

export default withStyles(styles)(bupBreakdownLD7);